import React from "react";
import { Fade } from "react-reveal";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ep1 from "../../assets/images/EP1.jpeg";
import ep2 from "../../assets/images/EP2.jpeg";
import ep3 from "../../assets/images/EP3.jpeg";
import ep4 from "../../assets/images/EP4.jpeg";
import ep5 from "../../assets/images/EP5.jpeg";
import ep6 from "../../assets/images/EP6.jpeg";
import "./Gallery.css";
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "#00693A",
        borderRadius: "50px",
        padding: "2px",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "#00693A",
        borderRadius: "50px",
        padding: "2px",
      }}
      onClick={onClick}
    />
  );
}
let eps = [
  {
    image: ep1,
    url: "https://www.youtube.com/watch?v=JeUF_L1gc4U&t=4285s",
    text: "LGW Webinar | Beyond the Ballot - Episode 1 - [Freedom of Speech] with Gino Raidy and Jana Massoud",
  },
  {
    image: ep2,
    url: "https://www.youtube.com/watch?v=4fm2A3dyb-M&t=202s",
    text: "LGW Webinar | Beyond the Ballot - Episode 2 - [Green Activism] with Jan Steurs and Wael Homaidan",
  },
  {
    image: ep3,
    url: "https://www.youtube.com/watch?v=MHzuoChyVww&t=480s",
    text: "Beyond the Ballot - Episode 3 - [LGBTQIA+] with Sandra Melhem, Miquel Bibiloni & Samir Chalhoub",
  },
  {
    image: ep4,
    url: "https://www.youtube.com/watch?v=sN206yYvupc&t=245s",
    text: "Beyond the Ballot - Episode 4 - [Women's Rights Advocacy] Melkar El Khoury and Soohee Lee",
  },
  {
    image: ep5,
    url: "https://www.youtube.com/watch?v=exxOPgkeFdU&t=270s",
    text: "Beyond the Ballot - Episode 5 - [Climate Justice Advocacy] Marinel Ubaldo and Hussein Ghandour",
  },
  {
    image: ep6,
    url: "https://www.youtube.com/watch?v=fuIZTMgRJpc",
    text: "Beyond the Ballot - Episode 6 - [Environmental Activism] Samer el Khoury and Zanna Vanrenterghem",
  },
];

const Gallery = () => {
  var settings = {
    dots: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    initialSlide: 0,

    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="flex flex-col justify-center items-center mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-16 2xl:mt-24 mx-[5%] relative">
      <p className="font-['FuturaExtraBold'] text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl text-[#00693A]">
        <Fade top>VIDEO GALLERY</Fade>
      </p>
      <div className=" sm:block shadow-2xl rounded-[50px] mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-16 2xl:mt-24 max-w-full mx-[1%] p-8 relative">
        <Slider {...settings} touchMove={false} className="max-w-full">
          {eps.map((item, index) => {
            return (
              <div
                onClick={(e) => {
                  e.preventDefault();
                  window.open(item.url);
                }}
                className="flip-card w-full min-w-[200px] sm:w-[200px] md:w-[250px] h-[200px] lg:w-[350px]"
                key={index}
              >
                <div className="flip-card-inner w-full min-w-[200px] sm:w-[200px] md:w-[250px] h-[200px] lg:w-[350px]">
                  <div
                    style={{
                      backgroundImage: `url(${item.image})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    className="flip-card-front w-full min-w-[200px] sm:w-[200px]  md:w-[250px] h-[200px] lg:w-[350px]"
                  />
                  <div
                    style={{
                      backgroundImage: `url(${item.image})`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    className="flip-card-back"
                  >
                    <div
                      style={{
                        background:
                          "linear-gradient(to right, rgba(0,138,200,0.8), rgba(0,105,58,0.8))",
                      }}
                      className="flex flex-col justify-center items-center text-sm sm:text-md md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl h-[200px] text-[white]"
                    >
                      <p className="p-1 xl:p-2">{item.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default Gallery;
